import { boot } from 'quasar/wrappers'
import { Cookies } from 'quasar'
import { api } from './axios'

export default boot(({ store, ssrContext }) => {
  if (Cookies.has('auth_token')) {
    store.dispatch('auth/isAuthenticated', true)
    api.defaults.headers.common['Authorization'] =
      'Bearer ' + Cookies.get('auth_token')
  }
})
